import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';

@Component({
    selector: 'tag',
    imports: [TagModule, TranslateModule],
    standalone: true,
    templateUrl: './tag.component.html',
    styleUrl: './tag.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent {
    id = input.required<string>();
    label = input.required<string>();

    severity = input<'info' | 'success' | 'warn' | 'danger' | 'secondary'>('info');
    rounded = input<boolean>(false);
}
